import * as React from 'react';
import DisciplinePage from '../../Components/DisciplinePage/DisciplinePage';
import Image from '../../img/pao-page.webp';

const SECTIONS = [
  {
    heading: 'Tecniche ed esercizi con il Pao',
    body: "Gli esercizi con il Pao spaziano da sequenze di base a combinazioni avanzate, adatti a tutti i livelli di esperienza. L'istruttore guida i praticanti attraverso vari esercizi, enfatizzando non solo la corretta postura e tecnica, ma anche l'importanza della presenza mentale e del controllo emotivo durante l'allenamento.",
  },
  {
    heading: 'Il Pao come strumento di crescita',
    body: "Nella Muay Thai, l'allenamento con il Pao è visto come un percorso verso la padronanza di sé, dove mente, corpo e spirito lavorano in armonia. La pratica regolare con il Pao insegna ai praticanti a rimanere focalizzati, calmi e presenti, trasformando l'allenamento fisico in un'esperienza meditativa e spiritualmente arricchente.",
  },
];

export default function PadPage() {
  return (
    <DisciplinePage
      kicker="Attività 02"
      title="PAO"
      intro="Il Pao è un attrezzo essenziale per l'allenamento in Muay Thai, utilizzato per migliorare precisione e potenza nei colpi. Permette di esercitarsi in sicurezza e simula situazioni di combattimento reale, essenziale per la pratica tecnica."
      sections={SECTIONS}
      image={Image}
    />
  );
}
